class frequentlyBoughtTogeather extends HTMLElement {
    constructor(){
        super();
        this.button = this.querySelector('.fbt-add-to-cart');
        this.totalSpan = this.querySelector('.fbt-add-to-cart-price');
        this.checkboxes = this.querySelectorAll('.fbt-checkbox');
    }

    connectedCallback() {
        this.button.addEventListener('click', this.handleAddToCart.bind(this));

        // Listen for checkbox changes to update price
        this.checkboxes.forEach(cb => {
            cb.addEventListener('change', this.updateButtonPrice.bind(this));
        });

        // Set initial price on load
        this.updateButtonPrice();
    }

    formatMoney(paise) {
        return '₹' + (paise / 100).toLocaleString('en-IN');
    }

    updateButtonPrice() {
        const total = this.getCheckedTotal();
        console.log('total', total);
        if (total > 0) {
            this.totalSpan.innerText = `Total: ${this.formatMoney(total)}`;
        } else {
            this.totalSpan.innerText = 'Please select any product to add.';
        }
    }

    getCheckedTotal() {
        let total = 0;
        this.checkboxes.forEach(cb => {
            if (cb.checked) {
                total += Number(cb.dataset.price) || 0;
            }
        });
        return total;
    }

    getCheckedVariantIds() {
        const ids = [];
        this.checkboxes.forEach(cb => {
            if (cb.checked) {
                ids.push(Number(cb.value));
            }
        });
        return ids;
    }

    async handleAddToCart() {
        const variantIds = this.getCheckedVariantIds();

        if (variantIds.length === 0) return;

        // Push CleverTap event
        if (typeof clevertap !== 'undefined' && clevertap.event && clevertap.event.push) {
            const checkedTitles = [];
            const checkedHandles = [];
            let totalPrice = 0;
            
            this.checkboxes.forEach(cb => {
                if (cb.checked) {
                    if (cb.dataset.title) checkedTitles.push(cb.dataset.title);
                    if (cb.dataset.handle) checkedHandles.push(cb.dataset.handle);
                    totalPrice += (Number(cb.dataset.price) || 0) / 100;
                }
            });

            const eventPayload = {
                "Products": checkedTitles.join(", "),
                "Handles": checkedHandles.join(", "),
                "Total Price": totalPrice,
                "Page URL": window.location.href
            };
            
            console.log("✅ CleverTap Event Fired: ATC_FBT", eventPayload);
            clevertap.event.push("ATC_FBT", eventPayload);
        } else {
            console.log("⚠️ CleverTap is not loaded on this page, but ATC_FBT would have fired.");
        }

        this.button.innerText = 'Adding…';
        this.button.disabled = true;

        try {
            const items = variantIds.map(id => ({
                id: id,
                quantity: 1
            }));

            const response = await fetch(routes.cart_add_url, {
                ...fetchConfig('javascript'),
                body: JSON.stringify({
                    items,
                    sections: ['cart-icon-bubble'],
                    sections_url: window.location.pathname
                })
            });

            if (!response.ok) throw new Error('Add to cart failed');

            const parsedState = await response.json();

            // Update cart icon bubble from section rendering response
            const bubble = document.getElementById('cart-icon-bubble');
            if (bubble && parsedState.sections?.['cart-icon-bubble']) {
                bubble.innerHTML = parsedState.sections['cart-icon-bubble'];
            }

            // Open the GoKwik side cart
            setTimeout(() => {
                window.openGokwikSideCart();
            }, 500);

        } catch (error) {
            console.error('FBT add to cart failed:', error);
        } finally {
            this.button.disabled = false;
            this.button.innerText = 'Add to cart';
        }
    }
}

customElements.define('frequently-bought-togeather', frequentlyBoughtTogeather);